import type { AxiosPromise } from 'axios';

import type { WelcomeData } from '@app/api/welcome';
import request from '@app/utils/request';

// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import type { ResetModalData } from './pages/LoginPage/LinkSentModal';
// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import type { LoginFormDataType } from './pages/LoginPage/types';
// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import type { ResetFormDataType } from './pages/ResetPage/types';
import type { TwoFactorFormDataType } from './pages/TwoFactorPage';
import type { SignupFormDataType } from './router/SignupRouter';
import type { ResponseRedirect } from './types';

export const login = (data: LoginFormDataType): AxiosPromise<ResponseRedirect> =>
    request({
        method: 'POST',
        url: '/login/signin',
        data,
    });

export const signup = (data: SignupFormDataType): AxiosPromise<ResponseRedirect> =>
    request({
        method: 'POST',
        url: '/signup/try',
        data,
    });

export const resetPassword = (data: ResetFormDataType): AxiosPromise<ResponseRedirect> =>
    request({
        method: 'POST',
        url: '/reset',
        data,
    });

export const welcomeData = (): AxiosPromise<WelcomeData> =>
    request({
        method: 'GET',
        url: '/welcome/data',
    });

export const twoFactorLogin = (data: TwoFactorFormDataType): AxiosPromise =>
    request({
        method: 'POST',
        url: '/login/two-factor',
        data,
    });

export const resetPasswordRequest = (email: string): AxiosPromise<ResetModalData> =>
    request({
        method: 'POST',
        url: '/login/reset',
        data: { email },
    });

export const ssoLogin = (domain: string): AxiosPromise =>
    request({
        method: 'GET',
        url: `/sso/${domain}`,
        headers: {
            'Content-Type': 'text/plain',
        },
    });
